import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecommerce-development-service',
  templateUrl: './ecommerce-development-service.component.html',
  styleUrls: ['./ecommerce-development-service.component.scss']
})
export class EcommerceDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
